import { useStorage } from './useStorage';

export interface ConnectionPreferences {
  skipBluetoothInfo: boolean;
  skipUsbInfo: boolean;
}

const DEFAULT_CONNECTION_PREFERENCES: ConnectionPreferences = {
  skipBluetoothInfo: false,
  skipUsbInfo: false,
};

const CONNECTION_PREFERENCES_KEY = 'connectionPreferences';

/**
 * Reads connection preferences directly from localStorage.
 * Use this when you need the current value at the moment of a user action,
 * since useConnectionPreferences state may be stale if another component updated storage.
 */
export const readConnectionPreferences = (): ConnectionPreferences => {
  try {
    const stored = typeof window !== 'undefined' && window.localStorage?.getItem(CONNECTION_PREFERENCES_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return { ...DEFAULT_CONNECTION_PREFERENCES, ...parsed };
    }
  } catch {
    // Ignore parse errors
  }
  return DEFAULT_CONNECTION_PREFERENCES;
};

export const useConnectionPreferences = () => useStorage<ConnectionPreferences>('local', CONNECTION_PREFERENCES_KEY, DEFAULT_CONNECTION_PREFERENCES);
